import './components/chart/index.js';
import './components/series-line/index.js';
import './components/series-area/index.js';
import './components/series-group/index.js';
import './components/series-group-column/index.js';
import './components/series-stack/index.js';
import './components/series-stack-area/index.js';
import './components/series-stack-column/index.js';
import './components/series-column/index.js';
